import Vue from 'vue';
import Router from 'vue-router';
import TimeTablePage from '@/views/TimeTablePage';
import OverviewPage from '@/views/OverviewPage.vue';
import LoginPage from '@/views/LoginPage.vue';
import ManualPage from '@/views/ManualPage.vue';
import NotesPage from '@/views/NotesPage';
import Loader from '@/components/Loader';
import RunStatusBlocked from '@/views/RunStatusBlocked';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: LoginPage,
      meta: { hideNavigation: true },
    },
    {
      path: '/loader',
      name: 'loader',
      component: Loader,
      meta: { hideNavigation: true, requiresAuthentication: true },
    },
    {
      path: '/',
      name: 'home',
      component: OverviewPage,
      meta: { requiresAuthentication: true },
    },
    {
      path: '/overview',
      name: 'overview',
      component: OverviewPage,
      meta: { requiresAuthentication: true },
    },
    {
      path: '/manual',
      name: 'manual',
      component: ManualPage,
      meta: { requiresAuthentication: true },
    },
    {
      path: '/notes',
      name: 'notes',
      component: NotesPage,
      meta: { requiresAuthentication: true }
    },
    {
      path: '/blocker',
      name: 'blocker',
      component: RunStatusBlocked,
      meta: { requiresAuthentication: true, hideNavigation: true, isBlocker: true },
    },
    {
      path: '/timetable',
      name: 'timetable',
      component: TimeTablePage,
      meta: { requiresAuthentication: true }
    }
  ],
});
